export const equifaxSample = [{
  "decision": "Deny",
  "timestamp": "2022-01-27T11:07:38.643+0000",
  "details": [
    {
      "key": "identityVerificationDecision",
      "value": "Approve"
    },
    {
      "key": "phoneInsights",
      "value": "Y"
    },
    {
      "key": "phoneInsightsReason",
      "value": "NoInsightsReturned"
    },
    {
      "key": "phoneVerification",
      "value": "Y"
    },
    {
      "key": "phoneVerificationReason",
      "value": "phoneTypeMobile"
    },
    {
      "key": "phoneAffiliation",
      "value": "Y"
    },
    {
      "key": "phoneAffiliationReason",
      "value": "accountNameFullMatch"
    },
    {
      "key": "phoneTrust",
      "value": "Y"
    },
    {
      "key": "emailInsights",
      "value": "Y"
    },
    {
      "key": "emailInsightsReason",
      "value": "NoInsightsReturned"
    },
    {
      "key": "emailVerification",
      "value": "Y"
    },
    {
      "key": "emailVerificationReason",
      "value": "emailExists"
    },
    {
      "key": "emailAffiliation",
      "value": "Y"
    },
    {
      "key": "emailAffiliationReason",
      "value": "accountNameFullMatch"
    },
    {
      "key": "emailTrust",
      "value": "Y"
    },
    {
      "key": "addressInsights",
      "value": "Y"
    },
    {
      "key": "addressInsightsReason",
      "value": "NoInsightsReturned"
    },
    {
      "key": "addressVerification",
      "value": "N"
    },
    {
      "key": "addressVerificationReason",
      "value": "addressNotValid,addressTypeNonResidential"
    },
    {
      "key": "addressAffiliation",
      "value": "Y"
    },
    {
      "key": "addressAffiliationReason",
      "value": "addressNameFullMatch"
    },
    {
      "key": "addressTrust",
      "value": "N"
    },
    {
      "key": "identityVerification",
      "value": "Y"
    },
    {
      "key": "identityVerificationReason",
      "value": "identityMatchAndAffiliation,identityMultipleMatch"
    },
    {
      "key": "identityResolution",
      "value": "Y"
    },
    {
      "key": "identityResolutionReason",
      "value": "identityStrongCorroboration"
    },
    {
      "key": "identityRisk",
      "value": "N"
    },
    {
      "key": "identityRiskReason",
      "value": "identityRiskLow"
    },
    {
      "key": "identityTrust",
      "value": "N"
    },
    {
      "key": "SSNInsights",
      "value": "Y"
    },
    {
      "key": "SSNInsightsReason",
      "value": "Multi-Identity SSN Affiliation"
    },
    {
      "key": "SSNVerification",
      "value": "Y"
    },
    {
      "key": "SSNVerificationReason",
      "value": "SSN Found"
    },
    {
      "key": "SSNAffiliation",
      "value": "Y"
    },
    {
      "key": "SSNAffiliationReason",
      "value": "Strong SSN Affiliation"
    },
    {
      "key": "SSNTrust",
      "value": "Y"
    },
    {
      "key": "dobInsights",
      "value": "Y"
    },
    {
      "key": "dobInsightsReason",
      "value": "DOB < 16"
    },
    {
      "key": "dobVerification",
      "value": "Y"
    },
    {
      "key": "dobVerificationReason",
      "value": "DOB Verified"
    },
    {
      "key": "dobAffiliation",
      "value": "Y"
    },
    {
      "key": "dobAffiliationReason",
      "value": "DOB Affiliated"
    },
    {
      "key": "dobTrust",
      "value": "Y"
    },
    {
      "key": "deviceReputation",
      "value": "Y"
    },
    {
      "key": "deviceReputationReason",
      "value": "deviceLowRisk"
    },
    {
      "key": "deviceAssociation",
      "value": "N"
    },
    {
      "key": "deviceAssociationReason",
      "value": "AffiliationNotConfirmed"
    },
    {
      "key": "deviceTrust",
      "value": "Y"
    }
  ],
  "kba": {
    "authenticationId": "d12e2ff7-36f7-4022-b265-4899e49addce",
    "questionnaire": {
      "questionnaireId": 1,
      "questionGroups": [
        {
          "questionGroup": "AUTO_LOAN",
          "appliesToQuestionId": [
            1,
            2
          ]
        },
        {
          "questionGroup": "STUDENT_LOAN",
          "appliesToQuestionId": [
            3
          ]
        }
      ],
      "questions": [
        {
          "questionId": 1,
          "questionText": "What is the total monthly payment for the above-referenced account?",
          "choiceType": {
            "type": "SINGLE_CHOICE"
          },
          "choices": [
            {
              "choiceId": 1,
              "choiceText": "$922 - $971"
            },
            {
              "choiceId": 2,
              "choiceText": "$972 - $1,021"
            },
            {
              "choiceId": 3,
              "choiceText": "$1,022 - $1,071"
            },
            {
              "choiceId": 4,
              "choiceText": "$1,072 - $1,121"
            },
            {
              "choiceId": 5,
              "choiceText": "NONE OF THE ABOVE"
            }
          ]
        },
        {
          "questionId": 2,
          "questionText": "What are the terms for the above-referenced account?",
          "choiceType": {
            "type": "SINGLE_CHOICE"
          },
          "choices": [
            {
              "choiceId": 1,
              "choiceText": "60 MONTHS"
            },
            {
              "choiceId": 2,
              "choiceText": "72 MONTHS"
            },
            {
              "choiceId": 3,
              "choiceText": "84 MONTHS"
            },
            {
              "choiceId": 4,
              "choiceText": "96 MONTHS"
            },
            {
              "choiceId": 5,
              "choiceText": "NONE OF THE ABOVE"
            }
          ]
        },
        {
          "questionId": 3,
          "questionText": "Your credit file indicates you may have a student loan, opened in or around July 2019. Who is the credit provider for this account?",
          "choiceType": {
            "type": "SINGLE_CHOICE"
          },
          "choices": [
            {
              "choiceId": 1,
              "choiceText": "BANK OF AMERICA CORP"
            },
            {
              "choiceId": 2,
              "choiceText": "CITIGROUP INC"
            },
            {
              "choiceId": 3,
              "choiceText": "JP MORGAN CHASE & CO"
            },
            {
              "choiceId": 4,
              "choiceText": "SLM CORPORATION"
            },
            {
              "choiceId": 5,
              "choiceText": "NONE OF THE ABOVE"
            }
          ]
        }
      ]
    },
    "kbaAuthentication": [
      {
        "key": "decision",
        "value": "pass"
      },
      {
        "key": "simpleScore",
        "value": "100"
      },
      {
        "key": "numberRealQuestionsNotAnswered",
        "value": "0"
      },
      {
        "key": "numberQuestionsGenerated",
        "value": "13"
      },
      {
        "key": "numberRealQuestionsPresented",
        "value": "0"
      },
      {
        "key": "numberRealQuestionsAnsweredCorrectly",
        "value": "0"
      },
      {
        "key": "numberFictionalQuestionsGenerated",
        "value": "13"
      },
      {
        "key": "numberFictionalQuestionsAnsweredCorrectly",
        "value": "3"
      },
      {
        "key": "numberRealQuestionsAnsweredIncorrectly",
        "value": "0"
      },
      {
        "key": "numberFictionalQuestionsAnsweredIncorrectly",
        "value": "0"
      },
      {
        "key": "numberQuestionsPresented",
        "value": "3"
      },
      {
        "key": "numberFictionalQuestionsPresented",
        "value": "3"
      },
      {
        "key": "numberFictionalQuestionsNotAnswered",
        "value": "0"
      },
      {
        "key": "numberRealQuestionsGenerated",
        "value": "0"
      },
      {
        "key": "allQuestionsPresentedWereReal",
        "value": "n"
      },
      {
        "key": "allQuestionsPresentedWereFictional",
        "value": "y"
      },
      {
        "key": "timeTakenAnswerQuestionnaireSession1",
        "value": "28"
      }
    ]
  },
  "originalTransactionId": "350fce1b-908e-4590-8666-ec3edcf79177"
}]


export const guestSearch = [
  {
    "data": [
        {
            "_id": {
                "timestamp": 1700587870,
                "date": "2023-11-21T17:31:10.000+00:00"
            },
            "reservationGuestId": 2403247,
            "reservationGuestIdText": "2403247",
            "guestId": 596478,
            "guestIdText": "596478",
            "organizationIdText": "250",
            "reservationIdText": "550280",
            "firstName": "Steve",
            "lastName": "Smith",
            "fullName": "Steve Smith",
            "createdDate": "2023-10-17T14:46:30.000+00:00",
            "lastEmailSent": "2023-10-17T14:46:31.000+00:00",
            "verifiedDate": "2023-10-17T14:46:30.000+00:00",
            "badGuestResultCode": null,
            "countyCriminalResultCode": null,
            "documentResultCode": null,
            "identityResultCode": null,
            "nationalCriminalResultCode": null,
            "sexOffenderResultCode": null,
            "watchlistResultCode": null,
            "verificationResultCode": null
        },
        {
            "_id": {
                "timestamp": 1700587845,
                "date": "2023-11-21T17:30:45.000+00:00"
            },
            "reservationGuestId": 2403219,
            "reservationGuestIdText": "2403219",
            "guestId": 596450,
            "guestIdText": "596450",
            "organizationIdText": "250",
            "reservationIdText": "550261",
            "firstName": "Steve",
            "lastName": "Grape",
            "fullName": "Steve Grape",
            "createdDate": "2023-09-29T14:58:37.000+00:00",
            "lastEmailSent": "2023-09-29T14:58:38.000+00:00",
            "verifiedDate": "2023-09-29T14:58:37.000+00:00",
            "badGuestResultCode": null,
            "countyCriminalResultCode": null,
            "documentResultCode": null,
            "identityResultCode": null,
            "nationalCriminalResultCode": null,
            "sexOffenderResultCode": null,
            "watchlistResultCode": null,
            "verificationResultCode": null
        },
        {
            "_id": {
                "timestamp": 1700587845,
                "date": "2023-11-21T17:30:45.000+00:00"
            },
            "reservationGuestId": 2403218,
            "reservationGuestIdText": "2403218",
            "guestId": 596449,
            "guestIdText": "596449",
            "organizationIdText": "250",
            "reservationIdText": "550260",
            "firstName": "Steve",
            "lastName": "Grape",
            "fullName": "Steve Grape",
            "createdDate": "2023-09-29T14:36:51.000+00:00",
            "lastEmailSent": "2023-09-29T14:36:53.000+00:00",
            "verifiedDate": "2023-09-29T14:36:51.000+00:00",
            "badGuestResultCode": null,
            "countyCriminalResultCode": null,
            "documentResultCode": null,
            "identityResultCode": null,
            "nationalCriminalResultCode": null,
            "sexOffenderResultCode": null,
            "watchlistResultCode": null,
            "verificationResultCode": null
        },
        {
            "_id": {
                "timestamp": 1700587845,
                "date": "2023-11-21T17:30:45.000+00:00"
            },
            "reservationGuestId": 2403217,
            "reservationGuestIdText": "2403217",
            "guestId": 596448,
            "guestIdText": "596448",
            "organizationIdText": "250",
            "reservationIdText": "550259",
            "firstName": "Steve",
            "lastName": "Grape",
            "fullName": "Steve Grape",
            "createdDate": "2023-09-29T14:14:28.000+00:00",
            "lastEmailSent": "2023-09-29T14:14:29.000+00:00",
            "verifiedDate": "2023-09-29T14:14:28.000+00:00",
            "badGuestResultCode": null,
            "countyCriminalResultCode": null,
            "documentResultCode": null,
            "identityResultCode": null,
            "nationalCriminalResultCode": null,
            "sexOffenderResultCode": null,
            "watchlistResultCode": null,
            "verificationResultCode": null
        },
        {
            "_id": {
                "timestamp": 1700587859,
                "date": "2023-11-21T17:30:59.000+00:00"
            },
            "reservationGuestId": 2403125,
            "reservationGuestIdText": "2403125",
            "guestId": 596358,
            "guestIdText": "596358",
            "organizationIdText": "250",
            "reservationIdText": null,
            "firstName": "Steve",
            "lastName": "Camper",
            "fullName": "Steve Camper",
            "createdDate": "2023-06-27T14:47:33.000+00:00",
            "lastEmailSent": null,
            "verifiedDate": "2023-06-27T14:47:33.000+00:00",
            "badGuestResultCode": "1001",
            "countyCriminalResultCode": null,
            "documentResultCode": "4001",
            "identityResultCode": "5001",
            "nationalCriminalResultCode": "4001",
            "sexOffenderResultCode": "4001",
            "watchlistResultCode": "4001",
            "verificationResultCode": "4001"
        },
        {
            "_id": {
                "timestamp": 1700587859,
                "date": "2023-11-21T17:30:59.000+00:00"
            },
            "reservationGuestId": 2402906,
            "reservationGuestIdText": "2402906",
            "guestId": 596139,
            "guestIdText": "596139",
            "organizationIdText": "250",
            "reservationIdText": "550031",
            "firstName": "Steve",
            "lastName": "Fountain",
            "fullName": "Steve Fountain",
            "createdDate": "2023-01-04T18:14:09.000+00:00",
            "lastEmailSent": "2023-01-04T18:14:09.000+00:00",
            "verifiedDate": "2023-01-04T18:14:09.000+00:00",
            "badGuestResultCode": "1001",
            "countyCriminalResultCode": null,
            "documentResultCode": "4001",
            "identityResultCode": null,
            "nationalCriminalResultCode": "4001",
            "sexOffenderResultCode": "4001",
            "watchlistResultCode": "4001",
            "verificationResultCode": "4001"
        },
        {
            "_id": {
                "timestamp": 1700587543,
                "date": "2023-11-21T17:25:43.000+00:00"
            },
            "reservationGuestId": 2349600,
            "reservationGuestIdText": "2349600",
            "guestId": 550596,
            "guestIdText": "550596",
            "organizationIdText": "250",
            "reservationIdText": "508790",
            "firstName": "Steve",
            "lastName": "Rehbein",
            "fullName": "Steve Rehbein",
            "createdDate": "2022-07-19T00:24:16.000+00:00",
            "lastEmailSent": "2022-07-08T03:20:05.000+00:00",
            "verifiedDate": "2022-07-19T00:24:16.000+00:00",
            "badGuestResultCode": "1001",
            "countyCriminalResultCode": null,
            "documentResultCode": null,
            "identityResultCode": "1001",
            "nationalCriminalResultCode": "1001",
            "sexOffenderResultCode": "1001",
            "watchlistResultCode": "1001",
            "verificationResultCode": "1001"
        },
        {
            "_id": {
                "timestamp": 1700587513,
                "date": "2023-11-21T17:25:13.000+00:00"
            },
            "reservationGuestId": 2318443,
            "reservationGuestIdText": "2318443",
            "guestId": 545890,
            "guestIdText": "545890",
            "organizationIdText": "250",
            "reservationIdText": "504305",
            "firstName": "Steve",
            "lastName": "Gordan",
            "fullName": "Steve Gordan",
            "createdDate": "2022-07-04T00:57:12.000+00:00",
            "lastEmailSent": "2022-07-03T16:04:53.000+00:00",
            "verifiedDate": "2022-07-04T00:57:12.000+00:00",
            "badGuestResultCode": "1001",
            "countyCriminalResultCode": null,
            "documentResultCode": null,
            "identityResultCode": null,
            "nationalCriminalResultCode": null,
            "sexOffenderResultCode": null,
            "watchlistResultCode": null,
            "verificationResultCode": "1001"
        },
        {
            "_id": {
                "timestamp": 1700587552,
                "date": "2023-11-21T17:25:52.000+00:00"
            },
            "reservationGuestId": 2326422,
            "reservationGuestIdText": "2326422",
            "guestId": 544102,
            "guestIdText": "544102",
            "organizationIdText": "250",
            "reservationIdText": "502534",
            "firstName": "Steve",
            "lastName": "Kingery",
            "fullName": "Steve Kingery",
            "createdDate": "2022-07-07T17:40:23.000+00:00",
            "lastEmailSent": "2022-07-02T10:51:58.000+00:00",
            "verifiedDate": "2022-07-07T17:40:23.000+00:00",
            "badGuestResultCode": "1001",
            "countyCriminalResultCode": null,
            "documentResultCode": null,
            "identityResultCode": null,
            "nationalCriminalResultCode": null,
            "sexOffenderResultCode": null,
            "watchlistResultCode": null,
            "verificationResultCode": "1001"
        },
        {
            "_id": {
                "timestamp": 1700587564,
                "date": "2023-11-21T17:26:04.000+00:00"
            },
            "reservationGuestId": 2361888,
            "reservationGuestIdText": "2361888",
            "guestId": 533669,
            "guestIdText": "533669",
            "organizationIdText": "250",
            "reservationIdText": "492603",
            "firstName": "Steve",
            "lastName": "Hertig",
            "fullName": "Steve Hertig",
            "createdDate": "2022-07-25T16:22:24.000+00:00",
            "lastEmailSent": null,
            "verifiedDate": "2022-07-25T16:22:24.000+00:00",
            "badGuestResultCode": "1001",
            "countyCriminalResultCode": null,
            "documentResultCode": null,
            "identityResultCode": null,
            "nationalCriminalResultCode": null,
            "sexOffenderResultCode": null,
            "watchlistResultCode": null,
            "verificationResultCode": "1001"
        }
    ],
    "totalRecords": 80
  }
]